import { AI_API_BASE_URL_V5, AI_API_BASE_URL_V7 } from '../config';

export const AIFeaturesAPIRoutes = {
  getAIFilters: () => `${AI_API_BASE_URL_V5}/filters`,
  vectorSearch: () => `${AI_API_BASE_URL_V5}/search_vector`,
  startAIChat: (workspaceId: number) => `${AI_API_BASE_URL_V7}/studio_chat/${workspaceId}`,
  getAIChatHistory: (workspaceId: number, chatId: number) =>
    `${AI_API_BASE_URL_V7}/studio_chat/${workspaceId}/${chatId}`,
  sendAIChatMessage: (workspaceId: number, chatId: number) =>
    `${AI_API_BASE_URL_V7}/studio_chat/${workspaceId}/${chatId}/messages`,
};
